export const GET_USER_PERMISSIONS_AND_ROLES_START = 'GET_USER_PERMISSIONS_AND_ROLES_START';
export const GET_USER_PERMISSIONS_AND_ROLES_SUCCESS = 'GET_USER_PERMISSIONS_AND_ROLES_SUCCESS';
export const GET_USER_PERMISSIONS_AND_ROLES_FAIL = 'GET_USER_PERMISSIONS_AND_ROLES_FAIL';

export const GET_USER_PERMISSIONS_START = 'GET_USER_PERMISSIONS_START';
export const GET_USER_PERMISSIONS_SUCCESS = 'GET_USER_PERMISSIONS_SUCCESS';
export const GET_USER_PERMISSIONS_FAIL = 'GET_USER_PERMISSIONS_FAIL';

export const SET_USER_PERMISSIONS_START = 'SET_USER_PERMISSIONS_START';
export const SET_USER_PERMISSIONS_SUCCESS = 'SET_USER_PERMISSIONS_SUCCESS';
export const SET_USER_PERMISSIONS_FAIL = 'SET_USER_PERMISSIONS_FAIL';

export const GET_CURRENT_USERS_PERMISSIONS_START = 'GET_CURRENT_USERS_PERMISSIONS_START';
export const GET_CURRENT_USERS_PERMISSIONS_SUCCESS = 'GET_CURRENT_USERS_PERMISSIONS_SUCCESS';
export const GET_CURRENT_USERS_PERMISSIONS_FAIL = 'GET_CURRENT_USERS_PERMISSIONS_FAIL';
